// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"fce19d8f","94":"e9980f63","120":"1391da0e","126":"fe4f3c01","171":"524029b4","407":"e7d0f233","432":"3538dca8","532":"fb7748f8","674":"5217acaa","684":"06e981e7","711":"27323c5b","744":"1c9f8c34","994":"9d123cc9"}[chunkId] + ".chunk.js";
};